import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {toast} from 'react-toastify';
import {Component, ComponentState} from '../../../../@types/component';
import {ComponentTreeEditorProps} from '../../../../@types/editor-props';
import componentService from '../../../../services/component.service';
import ComponentFaultTreeCanvas from './ComponentFaultTreeCanvas';

/**
 * The Fault tree tab of the Component editor. Ensures the Component (with its interior fault
 * tree) is loaded, then hands it to the JointJS canvas. A non-DRAFT Component opens read-only.
 */
export default function ComponentTreeEditor(props: ComponentTreeEditorProps): React.ReactElement {
    const {component, isActive, updateTab} = props;
    const [fetched, setFetched] = useState<Component | null>(null);

    useEffect(() => {
        if (!component?.id) {
            return;
        }
        // The tree is normally embedded already (fetchWorkspaceObject -> getComponent); refetch
        // only as a fallback so the canvas always has a fault tree to render.
        if (!component.faultTree) {
            componentService.getComponent(component.id)
                .then(setFetched)
                .catch((err: Error) => toast.error(err.message));
        }
    }, [component?.id, component?.faultTree]);

    const effective: Component | null = component?.faultTree ? component : fetched;

    if (!effective || !effective.faultTree) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 184px)'}}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <ComponentFaultTreeCanvas
            component={effective}
            isActive={isActive}
            readonly={effective.state !== ComponentState.DRAFT}
            updateTab={updateTab}
        />
    );
}
